import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ReviewsSummary,
  Text,
} from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { type FacilityProfile } from "@src/appV2/Facilities/types";
import { type RatingAggregates } from "@src/appV2/redesign/Workplace/Review/api/useGetRatingAggregates";
import { generatePath, useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_WORKPLACE_PROFILE_FULL_PATH } from "../../ShiftDiscovery/paths";

interface InHomeAgencyDetailsListItemProps {
  facilityRatings: RatingAggregates | undefined;
  facility: FacilityProfile;
}

export function InHomeAgencyDetailsListItem(props: InHomeAgencyDetailsListItemProps) {
  const { facilityRatings, facility } = props;

  const history = useHistory();

  return (
    <ListItemButton
      onClick={() => {
        history.push(
          generatePath(SHIFT_DISCOVERY_WORKPLACE_PROFILE_FULL_PATH, {
            workplaceId: facility.userId,
          })
        );
      }}
    >
      <ListItemIcon iconType="building" />
      <ListItemText
        disableTypography
        primary={
          <Text semibold variant="h6" sx={{ textWrap: "balance" }}>
            {facility.name}
          </Text>
        }
        secondary={
          <Stack spacing={4} marginTop={2}>
            <Text variant="body2">In-Home Agency</Text>
            {isDefined(facilityRatings) && (
              <ReviewsSummary
                rating={facilityRatings.avgRating}
                ratingsCount={facilityRatings.numberOfRatings}
                size="small"
              />
            )}
          </Stack>
        }
      />
    </ListItemButton>
  );
}
